import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Components
import ErrorBoundary from "./components/ErrorBoundary";

// Pages

import NotFoundPage from "./pages/NotFoundPage";
import ApplyPage from "./pages/ApplyPage";
import LanguagePage from "./pages/LanguageSelectPage";
import AboutPage from "./pages/AboutPage";
import ReportIssuePage from "./pages/ContactPage";
import MaintenancePage from "./pages/MaintenancePage";
// import SupportPage from "./pages/SupportPage";

// Context Providers

import { LanguageProvider } from "./context/LanguageContext";

// Create a React Query client
const queryClient = new QueryClient();

// Protected route component (temporarily disabled for development)

function App() {
  return (
    <LanguageProvider>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<LanguagePage />} />
              <Route path="/apply" element={<LanguagePage />} />
              <Route path="/apply/form" element={<ApplyPage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/report-issue" element={<ReportIssuePage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              {/* <Route path="/support" element={<SupportPage />} /> */}

              {/* Catch all unmatched routes */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Router>
        </QueryClientProvider>
      </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;
